import Relay from 'react-relay';
/**
*  Update User mutation
*/
export default class UpdateUserMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation{
      upUser
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
      user: {
        isTrustedUserToCreateCircles: this.props.validatePublicGroups,
        isTrustedUserToCreateActivities: this.props.validatePublicActivities,
        isTrustedUserToMakeMoneyTransferToAnyone: this.props.isTrustedUserToMakeMoneyTransferToAnyone,
        creation_status: this.props.statusField,
        sports: this.props.sportsField,
        fees: parseInt(this.props.feesField),
        authorized_managers: this.props.authorized_managers,
      },
      userID: this.props.user.id,
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on upUserPayload @relay(pattern: true){
        user {
          id
          authorized_managers
        }
      }
    `;
  }

  /**
  *  Config
  */
  getConfigs() {
    return [{
      type: 'FIELDS_CHANGE',
      fieldIDs: {
        user :this.props.user.id,
      },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
        id
      }
    `,
  }
}



// WEBPACK FOOTER //
// ./src/mutations/User/UpdateUserMutation.js